import { CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useFDTContextMenuConfig } from '../../contextMenu/context/FDTContextMenuConfigContext';
import { useMemo } from 'react';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { jsx as _jsx } from "react/jsx-runtime";
const Cell = ({
  CellComponent,
  columnIndex,
  rowIndex,
  columnNamespace,
  columnName,
  rowId,
  row,
  isCellVisible
}) => {
  // This id is part of our external api and should not be changed.
  // It will be used for features like coaching tips and onboarding tours.
  const externalId = `cell-${columnNamespace}-${columnName}-${rowId}`;
  const contextMenuConfig = useFDTContextMenuConfig();
  const triggerContextMenu = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.triggerContextMenu;
  const requiredCellProps = useMemo(() => {
    // HACK: These selectors are required for compatibility with onboarding tours
    // and coaching tips. When we've renamed the contact "name" column to it's
    // more permanent placeholder name, we should remove this and PR onboarding
    // tours/coaching tips to use the standardaized selectors.
    const onboardingSelectors = columnNamespace === CONTACT_TYPE_ID && ['name', 'email'].includes(columnName) ? {
      'data-onboarding': `contact-${columnName}-cell`
    } : {};
    return Object.assign({
      'data-table-external-id': externalId,
      'data-test-id': externalId,
      onContextMenu: triggerContextMenu ? e => {
        // if we leave e.preventDefault here, it prevents a the normal context menu from appearingA
        // this will need to be solved when we officially support cell context menus
        // this was disabled due to a customer support issue  https://git.hubteam.com/HubSpot/ProductSupport/issues/88328
        // e.preventDefault();
        e.stopPropagation();
        triggerContextMenu({
          row,
          columnName,
          columnNamespace
        });
      } : undefined
    }, onboardingSelectors, {
      'data-column-index': columnIndex
    });
  }, [externalId, triggerContextMenu, columnIndex, columnNamespace, columnName, row]);
  if (!isCellVisible) {
    return /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps));
  }
  const cellElement = /*#__PURE__*/_jsx(CellComponent, {
    rowIndex: rowIndex,
    columnIndex: columnIndex,
    columnNamespace: columnNamespace,
    columnName: columnName,
    row: row,
    requiredCellProps: requiredCellProps
  });
  const isContextMenuOpen = contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.getIsContextMenuOpen({
    row,
    columnName,
    columnNamespace
  });
  if (contextMenuConfig !== null && contextMenuConfig !== void 0 && contextMenuConfig.ContextMenuContentComponent && isContextMenuOpen) {
    //BUG: currently this will break table layouts as Popover injects a span as a sibling to the
    //element that it wraps.
    //We have de-scoped this for now as there are no consumers that immediately need this.
    //A possible solution is to cloneElement children and inject the popover around the content
    //of the <td> instead of on the td itself
    return /*#__PURE__*/_jsx(Popover, {
      arrowSize: "none",
      content: /*#__PURE__*/_jsx(contextMenuConfig.ContextMenuContentComponent, {
        columnName: columnName,
        columnNamespace: columnNamespace,
        row: row
      }),
      "data-test-id": "context-menu-popover",
      onOpenChange: () => {
        triggerContextMenu === null || triggerContextMenu === void 0 || triggerContextMenu({
          columnName: null,
          columnNamespace: null,
          row: null
        });
      },
      open: true,
      placement: "right bottom",
      children: cellElement
    });
  }
  return cellElement;
};
export default Cell;